import { useEffect, useMemo, useState } from 'react';
import { slugifyHeading } from '../../lib/api';
import { structureIfFlat } from '../../lib/structure';

export const extractToc = (md) =>
  structureIfFlat(md || '')
    .split('\n')
    .map((l) => l.match(/^(#{1,3})\s+(.+?)\s*#*\s*$/))
    .filter(Boolean)
    .map((m) => ({ level: m[1].length, text: m[2].replace(/[*_`]/g, ''), id: slugifyHeading(m[2].replace(/[*_`]/g, '')) }));

export default function PaperToc({ markdown, extra = [], onJump }) {
  const items = useMemo(() => [...extra, ...extractToc(markdown)], [markdown, extra]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    if (!items.length) return;
    const els = items.map((i) => document.getElementById(i.id)).filter(Boolean);
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setActive(e.target.id)),
      { rootMargin: '-20% 0px -70% 0px' }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [items]);

  if (!items.length) return null;
  return (
    <nav className="space-y-1" data-testid="paper-toc">
      <p className="font-mono-precision text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-5">Contents</p>
      {items.map((it) => (
        <button
          key={it.id}
          onClick={() => onJump(it.id)}
          className={`block w-full text-left text-[13px] leading-snug py-1.5 border-l transition-all duration-300 ${it.level === 3 ? 'pl-6' : 'pl-4'} ${
            active === it.id ? 'border-amber-400 text-amber-200' : 'border-white/[0.08] text-slate-500 hover:text-slate-300 hover:border-white/30'
          }`}
          data-testid={`toc-item-${it.id}`}
        >
          {it.text}
        </button>
      ))}
    </nav>
  );
}
